import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { InstructionAdditionalDataItem } from '../../Models/Models/Instructions/InstructionAdditionalDataItem';
import { ServiceValidationError } from '../../Core/DataTypes/ServiceValidation/ServiceValidationError';

declare var IS_RUNNING_IN_APP_POOL;

export class InstructionAdditionalDataItemClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(instructionId: number): Promise<Array<InstructionAdditionalDataItem>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Instruction/InstructionAdditionalDataItem/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { instructionId: instructionId }

    return AjaxWrapper.get<Array<InstructionAdditionalDataItem>, any>(url, data);
  }
  public put(instructionId: number, instructionAdditionalDataItem: Array<InstructionAdditionalDataItem>): Promise<Array<ServiceValidationError>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Instruction/InstructionAdditionalDataItem/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { instructionId: instructionId, instructionAdditionalDataItem: instructionAdditionalDataItem }

    return AjaxWrapper.put<Array<ServiceValidationError>, any>(url, data);
  }
}

